export const UPDATE_CANNED_RESPONSE_STATE = "UPDATE_CANNED_RESPONSE_STATE"
export const CANNED_RESPONSE_CREATED = 'CANNED_RESPONSE_CREATED';
export const CANNED_RESPONSE_UPDATED = 'CANNED_RESPONSE_UPDATED';
export const CANNED_RESPONSE_DELETED = 'CANNED_RESPONSE_DELETED';
